module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ThePageExternal', {
    attrs: {
      "title": 'SIGNIN__TITLE',
      "className": 'SignInView'
    }
  }, [_c('BaseText', {
    attrs: {
      "label": 'SIGNIN__EMAIL',
      "value": _vm.email,
      "errors": _vm.errors['email'],
      "autofocus": true,
      "icon": 'icon-mail'
    },
    on: {
      "change": function($event) {
        _vm.setEmail($event.target.value)
      },
      "enter": function($event) {
        _vm.signin()
      }
    }
  }), _vm._v(" "), _c('BaseText', {
    attrs: {
      "label": 'SIGNIN__PASSWORD',
      "value": _vm.password,
      "errors": _vm.errors['password'],
      "icon": 'icon-lock',
      "password": true
    },
    on: {
      "change": function($event) {
        _vm.setPassword($event.target.value)
      },
      "enter": function($event) {
        _vm.signin()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "SignInView__actions"
  }, [_c('BaseButtonFlat', {
    attrs: {
      "label": 'SIGNIN__FORGOT_PASSWORD',
      "class-name": 'SignInView__forgot-password'
    },
    on: {
      "click": function($event) {
        _vm.openForgotPassword()
      }
    }
  }), _vm._v(" "), _c('BaseButtonFlat', {
    attrs: {
      "label": 'SIGNIN__NEED_ACCOUNT',
      "class-name": 'SignInView__need-account'
    },
    on: {
      "click": function($event) {
        _vm.openSignUp()
      }
    }
  })], 1), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "label": 'SIGNIN__SIGN_IN'
    },
    on: {
      "click": function($event) {
        _vm.signin($event.target)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "SignInView__bottom"
  }, [_vm._v("\n        " + _vm._s(_vm.appName) + " " + _vm._s((new Date()).getFullYear()) + "\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-935e2a80"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SignInView.vue
// module id = 499
// module chunks = 1